import { DateTime } from 'luxon';

function luxonReviver(key: string, value: unknown) {
    // Register known field names to convert to minimise impact of converter
    // Omitting the field check will apply the DateTime conversion to every field that can be converted to a DateTime
    // Generally that'd be a good thing but including too many fields at this point would make the change set too large
    var fieldsToConvert = ["buildStartUtc", "buildEndUtc", "lotStartUtc", "lotEndUtc"];
    // Check if value is a string and is a valid ISO date
    if (fieldsToConvert.includes(key) && typeof value === "string") {
        const dt = DateTime.fromISO(value, { zone: "utc" });
        if (dt.isValid) {
            return dt;
        }
    }
    return value; // Return unchanged if not a valid ISO date
}

export default luxonReviver;